import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-checkbox',
  template: `
    <div [ngClass]="{
      'form-check': props.formCheck.indexOf('custom') === -1,
      'form-check-inline': props.formCheck === 'inline',
      'custom-control custom-checkbox': props.formCheck.indexOf('custom') === 0,
      'custom-control-inline': props.formCheck === 'custom-inline'
    }">
      <input type="checkbox"
        #checkboxEl
        [class.is-invalid]="showError"
        [class.form-check-input]="props.formCheck.indexOf('custom') === -1"
        [class.custom-control-input]="props.formCheck.indexOf('custom') === 0"
        [indeterminate]="props.indeterminate && formControl.value === null"
        [formControl]="formControl"
        [tabindex]="tabIndex"
        [id]="elementId"
        [formlyAttributes]="field">
      <label [for]="elementId"
        *ngIf="props.label"
        [class.form-check-label]="props.formCheck.indexOf('custom') === -1"
        [class.custom-control-label]="props.formCheck.indexOf('custom') === 0"
      >
        {{ props.label }}<span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
      </label>
      <label [for]="elementId"
        *ngIf="!props.label"
        [class.form-check-label]="props.formCheck.indexOf('custom') === -1"
        [class.custom-control-label]="props.formCheck.indexOf('custom') === 0"
      >
       <span class="wcag-visuallyhidden">checkbox label</span>
      </label>
    </div>
  `,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, FormlyModule],
})
export class FormlyFieldCheckboxExtraComponent extends FieldType<FieldTypeConfig> implements OnInit, AfterViewInit {

  @ViewChild('checkboxEl', { static: false }) checkboxEl: ElementRef;
  private hasUserInteracted = false;

  defaultOptions = {
    templateOptions: {
      indeterminate: false,
      hideLabel: true,
      dummyLabel: false,
      formCheck: 'custom', // 'custom' | 'stacked' | 'inline' | 'custom-inline'
    },
  };

  ngOnInit() {
    if (this.field.defaultValue === 'undefined') {
      this.field.defaultValue = false;
    }
    
    this.preventAutoControlTouchedOnInit();
   
  }

  ngAfterViewInit() {
    if (!this.props.skipFirstChange && this.props.change) {
      setTimeout(() => {
        if (!this.form.disabled) {
          const _event = new Event('change');
          _event['initial'] = true;
          this.checkboxEl.nativeElement.dispatchEvent(_event);
        }
      });
    }
    
    this.addUserInteractEventListner();
  } 

  get elementId(): string {
    if (this.field.id && this.field.id.includes('formly_')) {
      let prefix = this.form['id'];

      // check if in repeat section
      if (!prefix && this.field.parent.parent && this.field.parent.parent.parent && this.field.parent.parent.parent.type === 'repeat') {
        const cnt = this.field.parent.parent.key;
        prefix = `${this.field.parent.parent.parent['id']}_${cnt}`;
      }
      return `${prefix ? prefix + '_' : ''}${(this.key as string).replace('.', '_')}`;
    } else {
      return this.field.id;
    }
  }

  public get tabIndex(): number {
    return this.props.tabindex || this.field.hide ? -1 : 0;
  }

   private addUserInteractEventListner() {
    const checkboxElement = this.checkboxEl?.nativeElement;
    if (checkboxElement) {
      checkboxElement.addEventListener('click', () => {
        this.hasUserInteracted = true;
      }, { once: true });
    }
  }

  private preventAutoControlTouchedOnInit() {
    if (this.formControl) {
      const originalMarkAsTouched = this.formControl.markAsTouched.bind(this.formControl);
      this.formControl.markAsTouched = (opts?: any) => {
        // Only allow markAsTouched after user has actually interacted with the checkbox
        if (this.hasUserInteracted) {
          originalMarkAsTouched(opts);
        }
      };
    }
  }
}
